import { Modal, Card, CardContent, Typography, List, ListItem } from "@mui/material";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import { JSONTree } from "react-json-tree";
import { JSONTreeDarkTheme } from "utils/constant";
import { JSONTreeTheme } from "utils/constant";

const RouteModal = ({ selectedRouteGroup, setSelectedRouteGroup }) => {
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;
    return (
        <Modal
            open={!!selectedRouteGroup}
            onClose={() => setSelectedRouteGroup(null)}
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
        >
            <Card
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: { xs: "90%", sm: "50%", md: "40%" },
                    bgcolor: "white",
                    color: "#333",
                    boxShadow: 24,
                    p: 3,
                    borderRadius: 2,
                    maxHeight: "70vh",
                    overflowY: "auto",
                }}
            >
                <CardContent sx={{ color: '#fff' }}>
                    {selectedRouteGroup && (
                        <>
                            <MDTypography variant="h5" fontWeight="bold" gutterBottom>
                                Route: {selectedRouteGroup.route_id}
                            </MDTypography>

                            {/* Start Section */}
                            {selectedRouteGroup?.start && (
                                <>
                                    <MDTypography variant="subtitle1" fontWeight="bold">
                                        Started Group Id: {selectedRouteGroup.start[0]?.condition_group_id}
                                    </MDTypography>

                                    <MDTypography variant="subtitle1" fontWeight="bold">
                                        Started Parameters:
                                    </MDTypography>
                                    <List dense>
                                        {selectedRouteGroup.start.map((e, index) => (
                                            <ListItem key={index} sx={{ pl: 0 }}>
                                                {e.RouteConfigParameter.parameter_name} = {e.value}
                                            </ListItem>
                                        ))}
                                    </List>
                                </>
                            )}
                            <br />
                            {/* End Section */}
                            {selectedRouteGroup?.end && (
                                <>
                                    <MDTypography variant="subtitle1" fontWeight="bold">
                                        Ended Group Id: {selectedRouteGroup.end[0]?.condition_group_id}
                                    </MDTypography>

                                    <MDTypography variant="subtitle1" fontWeight="bold">
                                        Ended Parameters:
                                    </MDTypography>
                                    <List dense>
                                        {selectedRouteGroup.end.map((e, index) => (
                                            <ListItem key={index} sx={{ pl: 0 }}>
                                                {e.RouteConfigParameter.parameter_name} = {e.value}
                                            </ListItem>
                                        ))}
                                    </List>
                                </>
                            )}
                            <br />
                            {
                                selectedRouteGroup?.analysis ?
                                    <>
                                        <MDTypography variant="subtitle1" fontWeight="bold">
                                            AI Analysis
                                        </MDTypography>
                                        <JSONTree
                                            data={selectedRouteGroup?.analysis?.analysis_value}
                                            theme={darkMode ? JSONTreeDarkTheme : JSONTreeTheme}
                                            invertTheme={true}
                                            // shouldExpandNodeInitially={() => expand}
                                            labelRenderer={([key]) => (
                                                <span style={{ fontSize: "1rem" }}>{key}</span>
                                            )}
                                            valueRenderer={(raw) => (
                                                <span style={{ fontSize: "1rem" }}>{raw}</span>
                                            )}
                                            hideRoot={false}
                                        />
                                    </>
                                    : <></>
                            }
                            <br />
                            {
                                selectedRouteGroup?.startRouteLog ?
                                    <>
                                        <MDTypography variant="subtitle1" fontWeight="bold">
                                            Start Route Log
                                        </MDTypography>
                                        <JSONTree
                                            data={selectedRouteGroup?.startRouteLog}
                                            theme={darkMode ? JSONTreeDarkTheme : JSONTreeTheme}
                                            invertTheme={true}
                                            // shouldExpandNodeInitially={() => expand}
                                            labelRenderer={([key]) => (
                                                <span style={{ fontSize: "1rem" }}>{key}</span>
                                            )}
                                            valueRenderer={(raw) => (
                                                <span style={{ fontSize: "1rem" }}>{raw}</span>
                                            )}
                                            hideRoot={false}
                                        />
                                    </>
                                    : <></>
                            }
                            <br />
                            {
                                selectedRouteGroup?.endRouteLog ?
                                    <>
                                        <MDTypography variant="subtitle1" fontWeight="bold">
                                            End Route Log
                                        </MDTypography>
                                        <JSONTree
                                            data={selectedRouteGroup?.endRouteLog}
                                            theme={darkMode ? JSONTreeDarkTheme : JSONTreeTheme}
                                            invertTheme={true}
                                            // shouldExpandNodeInitially={() => expand}
                                            labelRenderer={([key]) => (
                                                <span style={{ fontSize: "1rem" }}>{key}</span>
                                            )}
                                            valueRenderer={(raw) => (
                                                <span style={{ fontSize: "1rem" }}>{raw}</span>
                                            )}
                                            hideRoot={false}
                                        />
                                    </>
                                    : <></>
                            }
                        </>
                    )}
                </CardContent>
            </Card>
        </Modal>
    );
};

export default RouteModal;
